export const WIZME_URL = process.env.REACT_APP_WIZME_URL;
